import URIS from 'constants/uris';
import http from 'services/http';

export function sendReport(params) {
  return http.post(URIS.SETTLEMENT_REPORTS, params);
}
